module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "eventEdit-modal view dark-top",
    attrs: {
      "dialog": "modal-lg"
    },
    on: {
      "close": _vm.cancelEdit
    }
  }, [_c('div', {
    staticClass: "fs-large mt-4 mb-3 text-center",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n      " + _vm._s(_vm.getBulkSelectedIds.length) + " Booking" + _vm._s((_vm.getBulkSelectedIds.length > 1) ? 's' : null) + " selected\n    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "bulkMainHolder d-flex w-100 h-100"
  }, [_c('div', {
    staticClass: "col-md-4 bg-lighter darker font-weight-600 px-0"
  }, [_c('ul', {
    staticClass: "h-100 bg-lightest"
  }, _vm._l((_vm.leftButtons), function(button) {
    return (button.enabled) ? _c('li', {
      staticClass: "py-3 pl-3 pointer",
      class: {
        'bg-lighter': button.selected
      },
      on: {
        "click": function($event) {
          return _vm.selectLeftButton(button)
        }
      }
    }, [_vm._v(_vm._s(button.label))]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c(_vm.activeArea, {
    tag: "div",
    attrs: {
      "bulkObject": _vm.bulkObject
    },
    on: {
      "closeModal": _vm.cancelEdit
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('footerButtons', {
    attrs: {
      "activeArea": _vm.activeArea,
      "bulkObject": _vm.bulkObject
    },
    on: {
      "submitBulk": _vm.submitBulk,
      "cancelEdit": _vm.cancelEdit
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4fd1d42a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fd1d42a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationsBulkActions.vue
// module id = 2080
// module chunks = 0